"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ]){
        // eslint-disable-next-line no-console
        console.log(initialState);
        this.initialState = this.boardDeepCopy(initialState);
        this.board = this.boardDeepCopy(initialState);
        this.score = 0;
        this.status = "idle";
    }
    moveLeft() {
        this.performMove((board)=>this.joinTiles(board));
    }
    moveRight() {
        this.performMove((board)=>{
            return this.reverse(this.joinTiles(this.reverse(board)));
        });
    }
    moveUp() {
        this.performMove((board)=>{
            const transposed = this.transpose(board);
            const joined = this.joinTiles(transposed);
            return this.transpose(joined);
        });
    }
    moveDown() {
        this.performMove((board)=>{
            const transposed = this.transpose(board);
            const reversed = this.reverse(transposed);
            const joined = this.joinTiles(reversed);
            const restored = this.reverse(joined);
            return this.transpose(restored);
        });
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.boardDeepCopy(this.board);
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    /**
   * Starts the game.
   */ start() {
        this.status = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    /**
   * Resets the game.
   */ restart() {
        this.status = "idle";
        this.board = this.boardDeepCopy(this.initialState);
        this.score = 0;
    }
    // Add your own methods here
    addRandomTile() {
        const emptyCells = this.board.reduce((acc, row, rowIndex)=>{
            row.forEach((cell, colIndex)=>{
                if (cell === 0) acc.push({
                    row: rowIndex,
                    col: colIndex
                });
            });
            return acc;
        }, []);
        if (emptyCells.length > 0) {
            const { row: row, col: col } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
            this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
        }
        if (this.isGameOver()) this.status = "lose";
    }
    joinTiles(board) {
        return board.map((line)=>{
            const filteredLine = line.filter((value)=>value !== 0);
            for(let i = 0; i < filteredLine.length; i++)if (filteredLine[i] === filteredLine[i + 1]) {
                filteredLine[i] *= 2;
                this.score += filteredLine[i];
                if (filteredLine[i] === 2048) this.status = "win";
                filteredLine.splice(i + 1, 1);
            }
            while(filteredLine.length < 4)filteredLine.push(0);
            return filteredLine;
        });
    }
    transpose(board) {
        return board[0].map((_, colInd)=>board.map((row)=>row[colInd]));
    }
    reverse(board) {
        return board.map((line)=>line.reverse());
    }
    boardDeepCopy(toCopy) {
        return JSON.parse(JSON.stringify(toCopy));
    }
    isGameOver() {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            const current = this.board[i][j];
            if (this.board[i][j] === 0 || i < 3 && current === this.board[i + 1][j] || j < 3 && current === this.board[i][j + 1]) return false;
        }
        return true;
    }
    performMove(moveFunction) {
        if (this.status !== "playing") return;
        const boardBeforeMove = JSON.stringify(this.board);
        this.board = moveFunction(this.board);
        if (JSON.stringify(this.board) !== boardBeforeMove) this.addRandomTile();
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
// Write your code here
const $09e991522ca7e64e$var$gameButton = document.querySelector(".button");
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game-score");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
document.addEventListener("keyup", (arrow)=>{
    if ($09e991522ca7e64e$var$game.status === "playing") {
        switch(arrow.key){
            case "ArrowUp":
                $09e991522ca7e64e$var$game.moveUp();
                break;
            case "ArrowDown":
                $09e991522ca7e64e$var$game.moveDown();
                break;
            case "ArrowRight":
                $09e991522ca7e64e$var$game.moveRight();
                break;
            case "ArrowLeft":
                $09e991522ca7e64e$var$game.moveLeft();
                break;
            default:
                break;
        }
        $09e991522ca7e64e$var$updateUi($09e991522ca7e64e$var$game.board);
        if ($09e991522ca7e64e$var$game.getStatus() === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
        if ($09e991522ca7e64e$var$game.getStatus() === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
    }
});
function $09e991522ca7e64e$var$updateUi(board) {
    const cells = $09e991522ca7e64e$var$gameField.querySelectorAll(".field-cell");
    board.flat().forEach((value, index)=>{
        const cell = cells[index];
        cell.textContent = value === 0 ? "" : value;
        cell.className = `field-cell ${value > 0 ? `field-cell--${value}` : ""}`;
    });
    $09e991522ca7e64e$var$gameScore.textContent = $09e991522ca7e64e$var$game.getScore();
}
$09e991522ca7e64e$var$gameButton.addEventListener("click", (e)=>{
    const button = e.target;
    if (button.classList.contains("start")) {
        $09e991522ca7e64e$var$game.start();
        button.classList.replace("start", "restart");
        button.textContent = "Restart";
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
        $09e991522ca7e64e$var$updateUi($09e991522ca7e64e$var$game.board);
    } else {
        $09e991522ca7e64e$var$game.restart();
        button.classList.replace("restart", "start");
        button.textContent = "Start";
        $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
        $09e991522ca7e64e$var$updateUi($09e991522ca7e64e$var$game.board);
    }
});


//# sourceMappingURL=index.29810d34.js.map
